import React from "react";
import KickImage from 'Reuseables/KickImage';
import classNames from "classnames";
import { connect } from "react-redux";
import { Modal, Container, Row, Col, Input } from "reactstrap";
import _ from "lodash";
import slugify from "react-slugify"

import {
  searchProduct,
  saveSearchQueries,
  searchModalProduct,
  doFetchPopularSearch,
  doFetchMostSearchResults,
  searchState,
  clickMenuNavbar
} from "../../actions/productAction";
import { doChangeCategory } from "../../actions/categoryAction";
import {
  doFetchProfile,
  doFetchCurrencyRate,
  doSignOut,
  doRefreshToken,
} from "../../actions/authAction";
import PageSearchResult from "../PageSearchResult";
import Analytics from '../../services/Analytics';
import { MODAL_SEARCH_TOGGLE } from "../../constants";
import IconClose from "../../images/cross.png";
import CloseIcon from "../../images/close-button-search.png";
import InputSearch from "../Forms/Input/InputSearch";

class ModalSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productCategories: null,
      isTyping: false,
      currentInputValue: "",
    };
    this.handleClick = this.handleClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleMappingSearchResult = this.handleMappingSearchResult.bind(this);
    this.handleButtonSearch = this.handleButtonSearch.bind(this);
    this.setFocus = this.setFocus.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.submitSearch = _.debounce(this.submitSearch, 2000);
  }

  componentDidUpdate(prevProps, prevState) {
    const { dataProduct } = this.props;
    const { productCategories, searchKeyword } = dataProduct;

    if (
      prevProps.modalSearchOpen !== this.props.modalSearchOpen &&
      this.props.modalSearchOpen
    ) {
      const { searchKeyword } = this.props.dataProduct;
      const searchKeywordTrim = searchKeyword
        ? searchKeyword.trim().toUpperCase() === "BROWSE ALL"
          ? ""
          : searchKeyword
            .trim()
            .replace(/\+/g, " ")
            .toUpperCase()
        : "";

        if (this.props.isClickMenu) this.setState({ currentInputValue: "" })
          else this.setState({ currentInputValue: searchKeywordTrim })

      setTimeout(() => {
        this.setFocus();
      }, 1);
    }

    if (
      prevProps.dataProduct.productCategories.categories !==
      productCategories.categories
    ) {
      if (productCategories.categories) {
        const ordered = {};
        Object.keys(productCategories.categories)
          .sort()
          .forEach(function (key) {
            ordered[key] = productCategories.categories[key];
          });
        this.setState({ productCategories: ordered });
      } else this.setState({ productCategories: null });
    }

  }

  handleClick(e) {
    e.preventDefault();
    this.setState({
      currentInputValue: e.target.textContent,
    });

    this.setFocus();
  }

  setFocus() {
    this.searchInput.focus();
  }

  handleKeyPress = (event) => {
    const {
      dataAuth,
      dataCategory: { selected },
      dataProduct: { caseSorting }
    } = this.props;
    if (event.key === "Enter") {
      const userId = dataAuth.isLogged ? dataAuth.userdata.id : null;
      const searchQuery = this.props.searchKeyword.replace(/\+/g, " ").toUpperCase();
      const category = selected === "bcaxkickavenue" ? "" : selected;
      let dataSearch = {
        user_id: userId,
        query: this.state.currentInputValue,
        category
      };
      const newCategory =
        selected === "apparels"
          ? "apparel"
          : selected === "handbags"
            ? "luxury"
            : selected === "bcaxkickavenue" ? "sneakers" : selected;
      this.props.onToggleModalSearch();

      let params =
        this.state.currentInputValue === ""
          ? "Browse All"
          : slugify(this.state.currentInputValue, { delimiter: '+' });;

      let manipulate = slugify(this.state.currentInputValue, { delimiter: '+' })

      const payload = {
        searchKeyword: manipulate.toLowerCase(),
        category: category === "bcaxkickavenue" ? "sneakers" : category.toLowerCase(),
        sort_by: caseSorting
      };

      this.props.history.push(
        `/search/${newCategory}/${params
          .trim()
          .split(" ")
          .join("+")
          .toLowerCase()}`
      );
      this.props.searchProduct(payload);

      if (this.state.currentInputValue !== "" && selected !== "bcaxkickavenue") {
        this.props.saveSearchQueries(dataSearch);
        Analytics.recordSearch(
          userId,
          searchQuery,
          category
        )
      }
      this.setState({
        isTyping: false,
      });
      this.props.searchState(this.state.currentInputValue);
      this.props.clickMenuNavbar(false);
    }
  };

  handleButtonSearch = () => {
    const {
      dataAuth,
      dataCategory: { selected },
      dataProduct: { caseSorting }
    } = this.props;
    const userId = dataAuth.isLogged ? dataAuth.userdata.id : null;
    const searchQuery = this.props.searchKeyword.replace(/\+/g, " ").toUpperCase();
    const category = selected === "bcaxkickavenue" ? "" : selected;
    let dataSearch = {
      user_id: userId,
      query: searchQuery,
      category
    };

    const newCategory =
      selected === "apparels"
        ? "apparel"
        : selected === "handbags"
          ? "luxury"
          : selected;

    this.props.onToggleModalSearch();
    let params =
      this.state.currentInputValue === "" ? "Browse All" : this.state.currentInputValue;
    let manipulate = this.state.currentInputValue
      .trim()
      .split(" ")
      .join("+");
    this.props.history.push(
      `/search/${newCategory}/${params
        .trim()
        .split(" ")
        .join("+")
        .toLowerCase()}`
    );
    const payload = {
      searchKeyword: manipulate.toUpperCase(),
      category: selected === "bcaxkickavenue" ? "" : selected,
      sort_by: caseSorting
    };
    this.props.searchProduct(payload);
    if (this.state.currentInputValue !== "" && selected !== "bcaxkickavenue") {
      this.props.saveSearchQueries(dataSearch);
      Analytics.recordSearch(
        userId,
        searchQuery,
        category
      )
    }
    this.setState({
      isTyping: false,
    });
  };

  handleChoosePopular = async (e, param) => {
    const categoryUrl =
      param === "apparels" || param === "Apparels"
        ? "apparel"
        : param === "handbags"
          ? "luxury"
          : param;

    const { searchKeyword } = this.props.dataProduct;
    const payload = {
      searchKeyword: searchKeyword.toLowerCase(),
      category: param === "bcaxkickavenue" ? "" : param.toLowerCase(),
    };
    this.props.searchProduct(payload);
    this.props.history.replace(
      `/search/${categoryUrl.toLowerCase()}/${searchKeyword
        .toLowerCase()
        .trim()
        .split(" ")
        .join("+")}`
    );
    this.props.onToggleModalSearch();
    this.props.doChangeCategory(param);
    this.setState({
      isTyping: false,
    });
  };

  handleOnClickRecent = async (e, keyword) => {
    const category = this.props.dataCategory.selected;
    const { caseSorting } = this.props.dataProduct;

    this.setState(
      {
        popularKeyword: keyword,
        isTyping: false,
      },
      () => {
        const payload = {
          searchKeyword: keyword.query.toLowerCase(),
          category: category === "bcaxkickavenue" ? "" : category.toLowerCase(),
          sort_by: caseSorting
        };
        const newCategory =
          category === "apparels"
            ? "apparel"
            : category === "handbags"
              ? "luxury"
              : category;

        this.props.onToggleModalSearch();
        this.props.searchProduct(payload);
        this.props.history.replace(
          `/search/${newCategory.toLowerCase()}/${payload.searchKeyword
            .toLowerCase()
            .trim()
            .split(" ")
            .join("+")}`
        );
      }
    );
  };

  handleClickPopular = async (e, keyword) => {
    e.preventDefault();
    this.setState(
      {
        isTyping: false,
        popularKeyword: keyword,
      },
      () => {
        this.props.searchState(keyword);

        const payload = {
          searchKeyword: keyword.query.toLowerCase(),
          category: keyword.category.name.toLowerCase(),
        };
        const newCategory =
          keyword.category.name === "apparels"
            ? "apparel"
            : keyword.category.name === "handbags"
              ? "luxury"
              : keyword.category.name;

        this.props.onToggleModalSearch();
        this.props.searchProduct(payload);
        this.props.history.replace(
          `/search/${newCategory.toLowerCase()}/${payload.searchKeyword
            .toLowerCase()
            .trim()
            .split(" ")
            .join("+")}`
        );
      }
    );
  };

  handleMappingSearchResult() {
    const {
      dataProduct,
      recentSearch,
      dataPopular,
      searchKeyword,
    } = this.props;
    const { productCategories, isTyping } = this.state;
    let sortedSearch = [];

    if (productCategories) {
      for (let category in productCategories) {
        sortedSearch.push([category, productCategories[category]]);
      }

      sortedSearch = sortedSearch.sort((a, b) => b[1] - a[1]);
    }

    return (
      <div>
        <div className="product_categories">
          {(isTyping || searchKeyword) &&
            productCategories &&
            sortedSearch.length > 0 &&
            sortedSearch.map((key, i) => {
              const categoryUrl =
                sortedSearch[i][0] === "apparels" ||
                  sortedSearch[i][0] === "Apparels"
                  ? "apparel"
                  : sortedSearch[i][0] === "handbags"
                    ? "luxury"
                    : sortedSearch[i][0];
              return (
                <div
                  className="product_categories__item"
                  onClick={(e) =>
                    this.handleChoosePopular(e, sortedSearch[i][0])
                  }
                  key={i}
                >
                  <span>
                    <bold>{sortedSearch[i][1]}</bold> Results found in{" "}
                    <bold style={{ textTransform: "capitalize" }}>
                      {categoryUrl}
                    </bold>
                  </span>
                </div>
              );
            })}
          {(isTyping || searchKeyword) && productCategories == null && (
            <div>
              <span>
                Oppss, seems like we do not have what you are looking for yet.
                Try a different keyword or query!
              </span>
            </div>
          )}
        </div>
        {(!isTyping && recentSearch.data.length > 0) ||
          (searchKeyword === "" && recentSearch.data.length > 0) ? (
          <div className="recent-search">
            <div className="recent-search-title">
              <span>Recent Search</span>
            </div>
            <Row>
              {recentSearch.data.map((item) => {
                return (
                  <Col xs={6} md={6}>
                    <span
                      key={item.id}
                      onClick={async (e) => this.handleOnClickRecent(e, item)}
                    >
                      {item.query}
                    </span>
                  </Col>
                );
              })}
            </Row>
          </div>
        ) : null}
        {(!isTyping &&
          dataPopular.hasOwnProperty("data") &&
          dataPopular.data.length > 0) ||
          (searchKeyword === "" &&
            dataPopular.hasOwnProperty("data") &&
            dataPopular.data.length > 0) ? (
          <div className="recent-search">
            <div className="recent-search-title">
              <span>Popular Search</span>
            </div>
            <Row>
              {dataPopular.data.map((shoe, index) => (
                <Col xs={6} md={6} key={index}>
                  <span
                    key={shoe.id}
                    onClick={async (e) => this.handleClickPopular(e, shoe)}
                  >
                    {shoe.query}
                  </span>
                </Col>
              ))}
            </Row>
          </div>
        ) : null}
      </div>
    );
  }

  handleClear() {
    this.props.searchState("");
  }

  onChange(e) {
    const cursorHandle = e.target.selectionStart;
    const element = e.target;

    window.requestAnimationFrame(() => {
      element.selectionStart = cursorHandle;
      element.selectionEnd = cursorHandle;
    });

    this.setState({
      currentInputValue: e.target.value
    }, () => {
      this.submitSearch();
    })
  }

  submitSearch() {
    let manipulate = this.state.currentInputValue
      .trim()
      .split(" ")
      .join("+");
    const keyword = this.state.currentInputValue.toLowerCase();
    const { selected } = this.props.dataCategory;
    const { caseSorting } = this.props.dataProduct;
    const payload = {
      searchKeyword: manipulate.toUpperCase(),
      category: selected === "bcaxkickavenue" ? "" : selected,
      sort_by: caseSorting
    };
    
    const payloads = {
      params: {
        keyword: keyword,
        availables: true,
        sort_by: caseSorting
      },
    };
    this.props.searchModalProduct(payload);
  }

  render() {
    const { searchKeyword } = this.props.dataProduct;
    const { dataCategory } = this.props;
    const newCategory =
      dataCategory.selected === "apparels"
        ? "apparel"
        : dataCategory.selected;
    return (
      <Modal
        size="100"
        className="search-custom-modal modal-fullscreen"
        modalClassName="modal-search"
        wrapClassName="wrapper-search"
        contentClassName="content-search"
        backdropClassName="backdrop-search-content"
        fade={false}
        isOpen={this.props.modalSearchOpen}
        toggle={this.props.onToggleModalSearch}
      >
        <div className="wrapper-modal-search">
          {/* <Container> */}
          <Row style={{ marginBottom: "15px" }}>
            <Col style={{ paddingLeft: "0px" }}>
              <p className="popular-search" style={{ margin: "0px" }}>
                Find your{" "}
                {newCategory === "bcaxkickavenue" ? "products" : newCategory}
              </p>
            </Col>
            <Col className="item-modal-active" style={{ paddingRight: 0 }}>
              <div onClick={this.props.onToggleModalSearch}>
                <KickImage className="btn-close-modal" src={CloseIcon} alt="close" />
              </div>
              {/* <KickImage className="btn-close-modal" onClick={this.props.onToggleModalSearch} src={IconClose} alt="close" /> */}
            </Col>
          </Row>
          <InputSearch
            name="keyword_search"
            placeholder="Search any products or SKU here"
            isSameInput={searchKeyword}
            onChange={this.onChange}
            onKeyPress={this.handleKeyPress}
            value={
              this.state.currentInputValue &&
                this.state.currentInputValue !== "Browse All"
                ? this.state.currentInputValue.replace(/\+/g, " ").toUpperCase()
                : ""
            }
            innerRef={(input) => (this.searchInput = input)}
            onClear={this.handleClear}
            onSubmit={this.handleButtonSearch}
          />
          {this.handleMappingSearchResult()}
          {/* </Container> */}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  dataAuth: state.dataAuth,
  dataProduct: state.dataProduct,
  dataPopular: state.dataProduct.productPopulars,
  recentSearch: state.dataProduct.recentSearch,
  modalSearchOpen: state.dataProduct.modalSearchOpen,
  dataCategory: state.dataCategory,
  searchKeyword:
    state.dataProduct.searchKeyword &&
      state.dataProduct.searchKeyword.hasOwnProperty("query")
      ? state.dataProduct.searchKeyword.query
      : state.dataProduct.searchKeyword,
  isClickMenu: state.dataProduct.isClickMenu
});

const mapDispatchToProps = (dispatch) => ({
  getProfile: () => dispatch(doFetchProfile()),
  doFetchCurrencyRate: (payload) => dispatch(doFetchCurrencyRate(payload)),
  signOut: () => dispatch(doSignOut()),
  searchProduct: (payload) => dispatch(searchProduct(payload)),
  searchModalProduct: (payload) => dispatch(searchModalProduct(payload)),
  saveSearchQueries: (dataSearch) => dispatch(saveSearchQueries(dataSearch)),
  getPopularSearch: (payload) => dispatch(doFetchPopularSearch(payload)),
  doRefreshToken: () => dispatch(doRefreshToken()),
  doToggleModalSearch: (payload) =>
    dispatch({ type: MODAL_SEARCH_TOGGLE, payload }),
  doFetchMostSearchResults: (payload) =>
    dispatch(doFetchMostSearchResults(payload)),
  searchState: (payload) => dispatch(searchState(payload)),
  doChangeCategory: (payload) => dispatch(doChangeCategory(payload)),
  clickMenuNavbar: bool => dispatch(clickMenuNavbar(bool))
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSearch);